/**
 * WineNot — Verificación de edad
 * +21 para USA, +18 para el resto de los países.
 * Se guarda en cookie por 30 días.
 *
 * INSTALACIÓN:
 * En Layout → theme.liquid, antes de </body>:
 * {{ 'winenot-age-check.js' | asset_url | script_tag }}
 */

(function () {

  if (window.Shopify && window.Shopify.designMode) return;

  const COOKIE_NAME = 'wn_age_verified';
  const COOKIE_DAYS = 30;

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function createPopup(minAge) {
    const style = document.createElement('style');
    style.textContent = `
      #wn-age-overlay {
        position: fixed;
        inset: 0;
        background: rgba(20, 12, 15, 0.93);
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        backdrop-filter: blur(4px);
      }
      #wn-age-box {
        background: #3a2c31;
        border: 1px solid #534049;
        border-radius: 12px;
        padding: 48px 40px;
        max-width: 460px;
        width: 100%;
        text-align: center;
        color: #f5f0ea;
        font-family: 'Poppins', sans-serif;
      }
      #wn-age-box .wn-logo {
        font-size: 13px;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: #c4a0b0;
        margin-bottom: 32px;
        font-weight: 500;
      }
      #wn-age-box h2 {
        font-size: 26px;
        font-weight: 600;
        margin: 0 0 12px;
        line-height: 1.2;
        color: #f5f0ea;
      }
      #wn-age-box p {
        font-size: 14px;
        color: #c4b0b8;
        margin: 0 0 36px;
        line-height: 1.6;
      }
      .wn-age-buttons {
        display: flex;
        gap: 12px;
        justify-content: center;
      }
      .wn-btn-yes {
        background: #534049;
        color: #f5f0ea;
        border: none;
        padding: 14px 32px;
        border-radius: 6px;
        font-family: 'Poppins', sans-serif;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        flex: 1;
        max-width: 180px;
        transition: background 0.2s;
      }
      .wn-btn-yes:hover { background: #6b5059; }
      .wn-btn-no {
        background: transparent;
        color: #c4b0b8;
        border: 1px solid #534049;
        padding: 14px 32px;
        border-radius: 6px;
        font-family: 'Poppins', sans-serif;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        flex: 1;
        max-width: 180px;
        transition: border-color 0.2s;
      }
      .wn-btn-no:hover { border-color: #c4a0b0; color: #f5f0ea; }
      #wn-age-denied { display: none; }
      #wn-age-denied h2 { font-size: 22px; margin-bottom: 16px; }
      #wn-age-denied p { margin-bottom: 0; }
      .wn-age-legal {
        margin-top: 28px;
        font-size: 11px;
        color: #8a7a80;
        line-height: 1.5;
      }
    `;
    document.head.appendChild(style);

    const overlay = document.createElement('div');
    overlay.id = 'wn-age-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Verificación de edad');

    overlay.innerHTML = `
      <div id="wn-age-box">
        <div id="wn-age-question">
          <div class="wn-logo">WineNot? Vinoteca</div>
          <h2>¿Sos mayor de ${minAge} años?</h2>
          <p>Este sitio vende bebidas alcohólicas.<br>Debés tener ${minAge} años o más para ingresar.</p>
          <div class="wn-age-buttons">
            <button class="wn-btn-yes" id="wn-btn-yes">Sí, tengo ${minAge}+</button>
            <button class="wn-btn-no" id="wn-btn-no">No, soy menor</button>
          </div>
          <p class="wn-age-legal">Al ingresar confirmás que tenés la edad legal para consumir alcohol en tu país de residencia.</p>
        </div>
        <div id="wn-age-denied">
          <h2>Acceso restringido</h2>
          <p>Lo sentimos, este sitio está destinado únicamente a mayores de ${minAge} años.</p>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    document.getElementById('wn-btn-yes').addEventListener('click', function () {
      setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
      overlay.remove();
      document.body.style.overflow = '';
    });

    document.getElementById('wn-btn-no').addEventListener('click', function () {
      document.getElementById('wn-age-question').style.display = 'none';
      document.getElementById('wn-age-denied').style.display = 'block';
    });
  }

  function init() {
    if (getCookie(COOKIE_NAME)) return;

    // Detectar país via Shopify
    fetch('/browsing_context_suggestions.json')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var country = data &&
          data.detected_values &&
          data.detected_values.country &&
          data.detected_values.country.handle
          ? data.detected_values.country.handle.toUpperCase()
          : null;

        // +21 para USA, +18 para el resto
        var minAge = (country === 'US') ? 21 : 18;
        createPopup(minAge);
      })
      .catch(function() {
        // Si falla la detección, mostrar +21 por seguridad
        createPopup(21);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();